<template>
  <v-card v-if="data">
    <slot name="title">
      <v-toolbar color="grey lighten-4" light tile flat>
        <v-toolbar-title centered class="headline font-weight-bold">{{ title }}</v-toolbar-title>
        <div class="flex-grow-1"></div>

        <v-spacer></v-spacer>
      </v-toolbar>
    </slot>

    <v-card-text>
      <v-data-table
        :headers="headers"
        :items.sync="data"
        :items-per-page="10"
        class="elevation-0"
        :single-expand="false"
        show-expand
        :sort-by="[this.sortBy]"
        :sort-desc="[this.sortOrder == 'desc' ? true : false]"
        :expanded.sync="expanded"
      >
        <template slot="item.event" slot-scope="{ item }">
          {{ item.event | title }}
        </template>
        <template slot="item.type" slot-scope="{ item }">
          {{ item.detail_type.toString().split("\\") }}
        </template>
        <template slot="item.reason_for_modification" slot-scope="{ item }">
          <div v-if="item.reason_for_modification">
            {{ item.reason_for_modification.replace(/^(.{10}[^\s]*).*/, "$1") | title }}...
          </div>
        </template>
        <template slot="item.user" slot-scope="{ item }">
          <div v-if="item.user">
            {{ item.user.full_name | title }}
          </div>
        </template>
        <template v-slot:expanded-item="{ headers, item }">
          <td :colspan="headers.length">
            <strong>Update Reason:</strong>
            <span v-if="item.reason_for_modification">{{ item.reason_for_modification }}</span>
            <span v-else>{{ "N/A" }}</span>
            <div v-if="item.changes">
              <strong>Before:</strong>
              <pre>{{ item.changes.before }}</pre>
            </div>
            <div v-if="item.changes">
              <strong>After:</strong>
              <div v-if="item.changes.after">
                <div
                  v-if="
                    item.changes.after.data &&
                    typeof item.changes.after.data === 'string' &&
                    item.changes.after.data.trim() !== ''
                  "
                >
                  <pre>data:{{ JSON.parse(item.changes.after.data) }}</pre>
                </div>
                <div v-else>
                  <pre>data:{{ item.changes.after }}</pre>
                </div>
              </div>
              <div v-else>[]</div>
            </div>
          </td>
        </template>
      </v-data-table>
    </v-card-text>
  </v-card>
</template>
<script>
export default {
  props: {
    data: Array,
    title: { default: "Activity" },
    sortBy: { default: "date" },
    sortOrder: { default: "desc" },
  },
  data() {
    return {
      expanded: [],
      headers: [
        {
          text: "Event",
          align: "start",
          sortable: false,
          value: "event",
        },
        {
          text: "Type",
          align: "start",
          sortable: false,
          value: "detail_type",
        },
        { text: "Date", value: "date" },
        { text: "Client", value: "client.name" },
        { text: "Updated By", value: "user" },
        { text: "", value: "data-table-expand" },
      ],
    };
  },
};
</script>
